module.exports = __webpack_public_path__ + "static/media/icone-servico.06abb97e.png";